import * as api from '../api';
import { shipmentBodfsTrackYourTruckRequest } from '../api/requestCreator';
import { getInputValue } from '../reducers/orderTracking';
import { setTrackYourTruckError, setDeliveryLinkTracking } from '../analytics/gatherService';

const updateBodfsTrackingDetail = (
  dispatch: Function,
  trackYourTruckResponse: Object,
  requestWorkOrderNumber: string,
  filter: string,
  groupIndex: string
) => {
  dispatch({
    type: 'FETCH_BODFS_DELIVERY_DETAIL_SUCCESS',
    id: `${requestWorkOrderNumber}_${groupIndex}`,
    response: trackYourTruckResponse,
    filter,
  });
};

const fetchBodfsShipmentTrackingDetail = (
  filter: string,
  bodfsDeliveries: Object,
  groupIndex: string
) => (dispatch: Function, getState: Function) => {
  const requestOrderNumber = getInputValue(getState(), 'order');
  const payload = shipmentBodfsTrackYourTruckRequest(
    bodfsDeliveries,
    requestOrderNumber
  );
  const { url, data } = payload;

  const { capReservationId = '' } = data.trackYourTruckRequest;

  const requestWorkOrderNumber = data.trackYourTruckRequest.workOrderNumber;
  data.trackYourTruckRequest.orderNumber = requestOrderNumber;

  dispatch({
    type: 'FETCH_BODFS_DELIVERY_DETAIL',
    id: requestWorkOrderNumber,
    filter,
  });

  api.postRequest(url, data).then(
    (response: Object) => {
      let { trackYourTruckResponse } = response.data;
      if (trackYourTruckResponse.trackerUrl && !trackYourTruckResponse.trackerUrl.includes('undefined')){
        setDeliveryLinkTracking(trackYourTruckResponse.trackerUrl);
      }

      if (capReservationId && trackYourTruckResponse.signatureURL) {
        api.getRequest(`/${trackYourTruckResponse.signatureURL}`).then(
          (responseSignature: Object) => {
            trackYourTruckResponse = Object.assign(
              { signatureData: responseSignature.data.signature },
              trackYourTruckResponse
            );

            // update store with response
            updateBodfsTrackingDetail(
              dispatch,
              trackYourTruckResponse,
              requestWorkOrderNumber,
              filter,
              groupIndex
            );
          },
          (error: Object) => {
            console.log(error);
            // update store with response
            updateBodfsTrackingDetail(
              dispatch,
              trackYourTruckResponse,
              requestWorkOrderNumber,
              filter,
              groupIndex
            );
          }
        );
      } else {
        // update store with response
        updateBodfsTrackingDetail(
          dispatch,
          trackYourTruckResponse,
          requestWorkOrderNumber,
          filter,
          groupIndex
        );
      }
    },
    (error: Object) => {
      console.log(error);

      const bodfsErrorResponse = {
        workOrderNumber: requestWorkOrderNumber,
        orderNumber: requestOrderNumber,
      };

      updateBodfsTrackingDetail(
        dispatch,
        bodfsErrorResponse,
        requestWorkOrderNumber,
        filter,
        groupIndex
      );
      setTrackYourTruckError();
    }
  );
};

export default fetchBodfsShipmentTrackingDetail;
